import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Condition = () => {
    return (
        <React.Fragment>
            <section className="section bg-light py-5">
                <Container>
                   <Row className="align-items-center gy-4">
                                           <div className="text-muted">
                                               <div className="text-center">
                                                   <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Terms & Conditions</h2>
                                               </div>
                                           </div>
                                       </Row>
                    <Row className="justify-content-center mt-4">
                        <Col lg={10}>
                            <ol style={{ lineHeight: '1.8', color: '#333' , textAlign: 'justify'}}>
                                <li>
                                    <strong>Acceptance of Terms</strong><br />
                                    By accessing this website, you agree to comply with and be bound by these Terms and Conditions. If you do not agree, please do not use our site.
                                </li>
                                <li>
                                    <strong>Use of Website</strong><br />
                                    This website is intended for informational and business communication purposes only.
                                    Users may interact via a secure login system and initiate contact via WhatsApp.
                                    Unauthorized use of the website may give rise to a claim for damages and/or be a criminal offense.
                                </li>
                                <li>
                                    <strong>User Accounts</strong><br />
                                    If you create an account on this website, you are responsible for maintaining the confidentiality of your login credentials.
                                    You agree to provide accurate and complete information when creating an account.
                                </li>
                                <li>
                                    <strong>WhatsApp Integration</strong><br />
                                    By initiating communication through WhatsApp, you consent to receive messages related to our products, services, and business updates.
                                </li>
                                <li>
                                    <strong>Intellectual Property</strong><br />
                                    All content on this website, including but not limited to logos, images, text, and design, is the property of Offiso India and protected by applicable copyright and trademark laws.
                                </li>
                                <li>
                                    <strong>Disclaimer</strong><br />
                                    We make every effort to ensure the information on our website is up to date and accurate, but we make no warranties of any kind, express or implied.
                                </li>
                                <li>
                                    <strong>Limitation of Liability</strong><br />
                                    Offiso India is not liable for any loss or damage arising from use of this website or our services, including WhatsApp communication.
                                </li>
                                <li>
                                    <strong>Third-Party Links</strong><br />
                                    We may include links to other websites or services. We are not responsible for their content or privacy practices.
                                </li>
                                <li>
                                    <strong>Changes to Terms</strong><br />
                                    We reserve the right to change or update these Terms at any time. Continued use of the website after such changes constitutes acceptance of the updated Terms.
                                </li>
                                <li>
                                    <strong>Governing Law</strong><br />
                                    These Terms shall be governed by and construed in accordance with the laws of India. Disputes shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.
                                </li>
                            </ol>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Condition;
